    import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
const { types } = require('sharetribe-flex-sdk');
const { Money } = types;

import css from './OrderBreakdown.module.css';

/**
 * A component that renders one split payment row (one participant share).
 *
 * @component
 * @param {Object} props
 * @param {intlShape} props.intl - The intl object
 * @param {Object} props.share - { index: number, amount: Money, labelId?: string }
 * @param {string?} props.labelId - Optional translation id override
 * @returns {JSX.Element|null}
 */
const LineItemSplitPayment = props => {
  const { intl, share, labelId } = props;

  if (!share?.amount) return null;

  const { index, amount } = share;

  const money = new Money(amount.amount, amount.currency);
  const formatted = formatMoney(intl, money);

  // Default label: "Participant 1", "Participant 2", etc.
  const message = (
    <FormattedMessage
      id={labelId || 'OrderBreakdown.splitPaymentParticipant'}
      values={{ participant: index + 1 }}
    />
  );

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>{message}</span>
      <span className={css.itemValue}>{formatted}</span>
    </div>
  );
};

LineItemSplitPayment.propTypes = {
  intl: intlShape.isRequired,
};

export default LineItemSplitPayment;
